const errorCode = {
  200101: "Your session has expired or an incorrect token was provided. Please log in again.",
  400101: "Account or password incorrect",
  400102: "Please enter a valid email address",
  400103: "Username not available (too short/long/already taken)",
  400104: "Invalid password; please set one with at least 8 characters.",
  400105: "Incorrect verification code; please verify the code sent to your email.",
  400106: "Too many requests; please try again later.",
  400107: "Please read and agree to the Creator Zone Terms of Service & Privacy Policy first.",
  400108: "Please link to at least one social media account and upload the dashboard screenshot.",
  400109: "Authorization failed; please try again.",
  400110: "Please select at least one content type.",
  400111: "Please select at least one game and enter your in-game UID and username.",
  400112: "Incorrect in-game UID; please check and try again.",
  400113: "Please enter your birthdate.",
  400114: "Please enter your region.",
  400115: "Please enter your Discord ID.",
  400116: "Submitted",
  400117: "Video data cannot be retrieved; please enter your video data manually.",
  400118: "Password incorrect",
  400119: "New password must differ from your current one; please try again.",
  400120: "Modification request has been submitted; please await staff review.",
  400121: "Screenshot format or size doesn't meet requirements; please retry.",
  400122: "Network connection interrupted or timed out. Please log in again.",
  400123: "Data error. Please close and try again.",
  400124: "Too many requests; please try again in 3 minutes.",
  400201: "The verification code or password is missing.",
  400202: "The email address has not been registered.",
  400203: "The email address is already taken.",
  400204: "The Discord ID is already taken.",
  400205: "Usernames can only be changed once every three months.",
  400206: "Please make sure you are over 18 years old.",
  400207: "You must first register as our creator.",
  400208: "Please don't make multiple requests.",
  400209: "Please apply for Creator Assets first.",
  400210: "Please enter your video link.",
  400211: "Upload failed, as the video link is already present in your account.",
  400212: "Upload failed",
  400213: "You have already become a registered Farlight 84 Creator!",
  400214: "To connect to a new game, real name verification is required.",
  400218: "Please ensure the video you upload is from your own platform. <br />(If your TikTok account name has changed, please re-connect your TikTok account in your profile page)",
  400234: "Your account has been blacklisted due to fraudulent activity. If you believe this is an error, please contact our support team (farlight84-service@farlightgames.com) for further assistance."
};

export default errorCode;